import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    // MUI 5 баг с notched=true
    '& legend': {
      width: 0,
    },
    '& .MuiOutlinedInput-root': {
      borderRadius: 100,
      '& fieldset': {
        borderColor: '#E7E7EC',
      },
    },
    '& .MuiOutlinedInput-input': {
      padding: '0 12px',
      color: '#65657B',
      fontWeight: 500,
      fontSize: 14,
      height: 32,
    },
    '& *::-webkit-calendar-picker-indicator': {
      filter: 'invert(0.6)',
    },
  },
}));

export const FilterDatepicker = ({
  form,
  field,
  onChange,
  label,
  min,
  max,
  ...props
}) => {
  const classes = useStyles();

  return (
    <FormControl className={classes.field}>
      <span className={classes.field_title}>{label}</span>
      <TextField
        error={form.errors[field.name]}
        classes={{ root: classes.textField }}
        type="date"
        sx={{ width: 150 }}
        onChange={(e) => onChange(e.target.value)}
        InputLabelProps={{ shrink: true }}
        InputProps={{ inputProps: { min, max } }}
        value={field.value}
        helperText={form.errors[field.name]}
        notched
        {...props}
      />
    </FormControl>
  );
};
